import { format, subDays, startOfWeek, startOfMonth } from 'date-fns';
import { Input } from '@/components/ui/input';

const fmt = (d) => format(d, 'yyyy-MM-dd');

export const PRESETS = [
  { key: 'today', label: 'Today', range: (t) => [t, t] },
  { key: 'yesterday', label: 'Yesterday', range: (t) => [subDays(t, 1), subDays(t, 1)] },
  { key: 'this_week', label: 'This week', range: (t) => [startOfWeek(t, { weekStartsOn: 1 }), t] },
  { key: 'last_7', label: 'Last 7 days', range: (t) => [subDays(t, 6), t] },
  { key: 'this_month', label: 'This month', range: (t) => [startOfMonth(t), t] },
  { key: 'last_30', label: 'Last 30 days', range: (t) => [subDays(t, 29), t] },
];

export const presetRange = (key) => {
  const p = PRESETS.find(x => x.key === key) || PRESETS[0];
  const [s, e] = p.range(new Date());
  return { start: fmt(s), end: fmt(e) };
};

export function PeriodPicker({ preset, start, end, onChange }) {
  const pill = (active) => `px-3 py-1 rounded-full text-sm border transition-colors ${active ? 'bg-orange-500 text-white border-orange-500' : 'hover:border-orange-300 bg-white'}`;
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="period-picker">
      {PRESETS.map(p => (
        <button key={p.key} onClick={() => onChange({ preset: p.key, ...presetRange(p.key) })}
          className={pill(preset === p.key)} data-testid={`period-${p.key}`}>{p.label}</button>
      ))}
      <button onClick={() => onChange({ preset: 'custom', start, end })} className={pill(preset === 'custom')} data-testid="period-custom">Custom</button>
      {preset === 'custom' && (
        <div className="flex items-center gap-1">
          <Input type="date" value={start} max={end} onChange={e => onChange({ preset: 'custom', start: e.target.value, end })}
            className="h-8 w-40" data-testid="period-start" />
          <span className="text-sm text-muted-foreground">to</span>
          <Input type="date" value={end} min={start} onChange={e => onChange({ preset: 'custom', start, end: e.target.value })}
            className="h-8 w-40" data-testid="period-end" />
        </div>
      )}
    </div>
  );
}
